import uuid from 'uuid'
import { orderByOrdering } from '@/utils/ordering'

function removeOperators (part, diagram) {
  const iterator = part.memberParts
  const toRemove = []
  if (iterator) {
    while (iterator.next()) {
      const s = iterator.value
      if (s.data.isOperator) {
        toRemove.push(s)
      }
    }
    for (let s of toRemove) {
      diagram.remove(s)
    }
  }
}

function insertOperators (part, diagram, operator, groupKey) {
  const iterator = part.memberParts
  const toAdd = []
  let minOrdering = null
  if (iterator) {
    while (iterator.next()) {
      const s = iterator.value
      if (minOrdering === null || s.data.ordering < minOrdering) {
        minOrdering = s.data.ordering
      }
    }
    if (minOrdering === null) {
      minOrdering = 10
    }
    iterator.reset()
    const parts = []
    while (iterator.next()) {
      parts.push(iterator.value)
    }
    parts.sort(orderByOrdering)
    parts.forEach((s, index) => {
      if (index !== parts.length - 1) { // i.e. not last one
        const oneAfter = index === parts.length - 1 ? null : parts[index + 1]
        if (oneAfter && (s.data.isGroup || oneAfter.data.isGroup)) {
          toAdd.push(
            {
              key: uuid(),
              text: operator,
              isOperator: true,
              category: 'Operator',
              isInPalette: false,
              ordering: s.data.ordering + 5,
              group: groupKey,
              isParentExcludedInQuery: part.data.isParentExcludedInQuery
            }
          )
        }
      }
    })
    diagram.model.addNodeDataCollection(toAdd)
  }
}

export { removeOperators, insertOperators }



// WEBPACK FOOTER //
// ./src/graph_parts/operators.js